import React from 'react';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import ReactOnRails from 'react-on-rails';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import getMessages from '../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../hooks/useCurrency';
import AdminUserValuationContainer from '../../containers/Admin/AdminUserValuationContainer.jsx';

const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: { 'X-CSRF-Token': ReactOnRails.authenticityToken() },
  }),
  cache: new InMemoryCache(),
});

// Functional generator (props, railsContext) so the i18n locale and currency
// come from the Rails-supplied context — the same way every other startup entry
// point resolves them. MultiLineValuation (rendered deep in the container) calls
// useIntl() in ~10 places; without IntlProvider here react-intl throws and the
// page white-screens. CurrencyProvider mirrors MultiLineValuationContainer so the
// admin/impersonation view formats currency for the right tenant, not always USD.
const AdminUserValuationPage = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  const currency = (railsContext && railsContext.currency) || window.currency || 'USD';

  return (
    <CurrencyProvider currency={currency}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <AdminUserValuationContainer {...props} />
          </BrowserRouter>
        </ApolloProvider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default AdminUserValuationPage;
